module.exports = __webpack_public_path__ + "static/skills-c6008a7aa14d2f232d0432bcd52051de.svg";